module.exports = __webpack_public_path__ + "static/media/manabi_01_en.8f5dcd2f.png";